import React from 'react';

import i18n from 'i18';

// @mui
import { TableCell } from '@mui/material';

// Text, Number, Items cells are similar
export default class GridItemsCell extends React.Component {
    render() {
        // props: value, id, field
        const translationKey = this.props.value
            ? `enums.${this.props.value}`
            : '';
        let translated = translationKey ? i18n.t(translationKey) : '';
        // Fallback: if translation missing (returns the key) show plain value instead
        if (translated === translationKey) {
            translated = this.props.value || '';
        }
        const value = translated;
        return <TableCell align="left">{value}</TableCell>;
    }
}
